import { Body1, H4 } from '@xo-union/tk-ui-typography';
import React, { ReactNode } from 'react';

import { TripleAction } from '.';
import styles from './confirmation.scss';

interface Props {
  onPrimaryAction: Function;
  primaryText: string;
  onSecondaryAction?: Function;
  secondaryText?: string;
  onTertiaryAction?: Function;
  tertiaryText?: string;
  question: string;
  info?: string | ReactNode;
  showSpinner?: boolean;
}

export const Confirmation: React.FC<Props> = ({
  onPrimaryAction,
  primaryText,
  onSecondaryAction,
  secondaryText,
  onTertiaryAction,
  tertiaryText,
  question,
  info,
  showSpinner,
  ...rest
}) => (
  <div className={styles.container} {...rest}>
    <H4>{question}</H4>
    {info && <Body1>{info}</Body1>}
    <TripleAction
      className={styles.tripleBtn}
      primaryText={primaryText}
      primaryOnClick={onPrimaryAction}
      secondaryText={secondaryText}
      secondaryOnClick={onSecondaryAction}
      tertiaryText={tertiaryText}
      tertiaryOnClick={onTertiaryAction}
      showSpinner={showSpinner}
    />
  </div>
);
